//Layout
import Header from 'layout/header/Header';
import Capsule from 'layout/Capsule';

//Components

//Assets
import { IoCloseCircleOutline, IoCloseOutline, IoCloudUploadOutline, IoDocument, IoDownload, IoInformationCircle, IoOpenOutline, IoPencil, IoPricetag, IoPricetags, IoRemoveOutline, IoTime } from 'react-icons/io5';

//Logic
import usePlan from './usePlan';
import { Offcanvas, ProgressBar } from 'react-bootstrap';
import OffcanvasServiceInfo from 'components/offcanvas/OffCanvasProductServiceInfo';
import SkeletonDiv from 'components/loader/SkeletonDiv';
import Checkout from 'components/Checkout';
import useOrder from 'hooks/useOrder';
import ModalConfirm from 'components/ModalConfirm';
import InputUpload from 'components/InputUpload';
import { numb } from 'utils/helpers';
import planImg from './img/plan.jpg';

function ProductLine({
    isSkeleton,
    product,
    onServiceInfo,
    onSelect = () => { }
}) {
    
    return (
        <div className="form-check">
            <input 
                type="radio" 
                className="form-check-input" 
                onChange={() => onSelect(product.id)}
                checked={!!product?.is_selected}
                id={`product_${product?.id}`}
            />
            <label className="form-check-label" htmlFor={`product_${product?.id}`}>
                <div className="flex-fill">
                    <div className="service-title service-title d-flex justify-content-between">
                        <span>{isSkeleton ? <SkeletonDiv /> : product.description}</span>
                        {isSkeleton ? <SkeletonDiv w="50px"/> : <>
                            <span className="d-inline-block active text-14 text-end align-self-baseline nowrap">
                                <IoInformationCircle 
                                    className="info-icon float-start" 
                                    onClick={() => onServiceInfo(product.id)}
                                />
                                {product?.price_matrix.price}€
                            </span>
                        </>}
                    </div>
                </div>
            </label>
        </div>
    );
}

function Plan() {

    const {
        products,
        handleSelectProduct,
        showOffCanvasServiceInfo, setShowOffCanvasServiceInfo,
        cartItems,
        handleInputUpload,
        removeFile,
        instructions, handleChangeInstructions,
        qty, handleChangeQty,
        placeOrder,
        isInProgress,
        isCartInProgress,
        handlePlaceOrder,
        completedOrderData,
        handleCloseModalConfirm,
        plan,
        ukey,
        couponData,
        applyCoupon
    } = usePlan();

    const is_disabled = qty <= 1;

    const order_total = cartItems?.price ?? 0;
    const order_total_vati = order_total * 1.22;

    return (
        <>
            <Header
                pageTitle={'Planimetria 2D/3D'}
                handleBack="home"
            />
            <Capsule>

                <div style={{
                    maxHeight: '200px',
                    overflow: 'hidden',
                    backgroundColor: '#f6f6f6',
                    backgroundImage: `url(${planImg})`,
                    height: '300px',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                }}
                ></div>


                <div className="header-large-title mt-3">
                    <h2 className="title lh-1">Richiedi una planimetria 2D o 3D</h2>
                </div>

                <div className="section rounded mt-2">
                    <h4 className="card-subtitle text-white pt-1 text-12">Seleziona la tipologia:</h4>

                    <div className="wide-block p-0 rounded">
                        <div className="input-list service-items service-items-plan">
                            {products ? products.map(product => (
                                <ProductLine 
                                    key={product.id} 
                                    product={product}
                                    onSelect={handleSelectProduct}
                                    onServiceInfo={setShowOffCanvasServiceInfo}
                                />
                            )) : Array(2).fill(null).map((_, i) => <ProductLine key={i} isSkeleton />)}
                        </div>
                    </div>

                </div>
                
                {cartItems?.products.length ? <>
                    <div className='section mt-3'>
                        <h4 className="card-subtitle text-white text-12 mb-0">Carica la planimetria da elaborare:</h4>
                        <i className='text-12 mb-2 d-block lh-base'>
                            Carica la planimetria in JPG/JPEG o in PDF, assicurati che ci sia una misura di una parete e che ci sia la disposizione dell’arredamento.
                        </i>
                        <InputUpload
                            gkey={ukey}
                            accept=".png, .jpg, .jpeg, .heic, .pdf"
                            limit={1}
                        />
                    </div>

                    <div className="section mt-3">
                        <h4 className="card-subtitle text-white text-12">NOTE AGGIUNTIVE:</h4>
                        <div className="form-group boxed custom pt-0">
                            <div className="input-wrapper">
                                <textarea 
                                    rows="3" 
                                    className="form-control bg-amazon"
                                    placeholder="Scrivi qui il tipo di pavimento da utilizzare o altre note" 
                                    value={instructions}
                                    onChange={handleChangeInstructions}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="section mt-3">
                        <h4 className="card-subtitle text-white text-12 mb-0">Quanti piani ha l'immobile?</h4>
                        <i className='text-12 mb-1 d-block lh-base'>
                        Se selezioni un solo piano e l’immobile è disposto su più livelli, realizzeremo esclusivamente il piano principale, solitamente quello con la zona giorno
                        </i>
                        <ul className="listview no-after image-listview bg-transparent no-border p-0 mt-1 m-0">
                            <li>
                                <div className="item p-0" style={{ minHeight: '33px' }}>
                                    <div className="in">
                                        <div className='fw-600'>Numero di piani</div>
                                        <div>
                                            <div className="stepper stepper-primary" style={{ height: '25px', width: '90px', minWidth: '90px', borderRadius: '6px', display: 'inline-flex', alignItems: 'flex-start', justifyContent: 'space-between', overflow: 'hidden' }}>
                                                <a
                                                    disabled
                                                    className={`render-ambient stepper-button stepper-down ${is_disabled ? 'disabled' : ''}`}
                                                    onClick={() => is_disabled ? null : handleChangeQty(qty - 1)}
                                                >-</a>
                                                <input 
                                                    value={qty}
                                                    type="text" 
                                                    readOnly
                                                    className="form-control text-white text-14" 
                                                    style={{ backgroundColor: 'transparent', borderColor: 'transparent', padding: '0 3px', width: '33px', height: '25px' }}
                                                />
                                                <a 
                                                    className="render-ambient stepper-button stepper-up" 
                                                    onClick={() => handleChangeQty(qty + 1)}
                                                >+</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                    </div>

                    <div className="section mt-2 mb-3">
                        <div className="section-title">
                            <h4 className="card-subtitle text-white text-12 mb-0">Riepilogo</h4>
                        </div>
                        <div className="card">
                            <ul className="listview simple-listview text-14 rounded">
                                <li className="bg-gray-dark fw-600">
                                    Subtotale
                                    <span className="active">
                                        <span className="fw-600 right-price">{numb(order_total)}€</span>
                                    </span>
                                </li>
                                <li className="bg-gray-dark fw-600">
                                    Totale (IVA inclusa)
                                    <span className="active">
                                        <span className="fw-600 right-price ms-2">
                                            {numb(order_total_vati)}€
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <Checkout 
                        cartItems={cartItems}
                        isInProgress={isInProgress || !cartItems?.products.length || !Object.keys(plan ?? {}).length}
                        isCartInProgress={isCartInProgress}
                        completeCheckout={handlePlaceOrder}
                        couponData={couponData}
                        applyCoupon={applyCoupon}
                    />
                </> : ''}
            </Capsule>
            <OffcanvasServiceInfo
                product={showOffCanvasServiceInfo}
                handleClose={() => setShowOffCanvasServiceInfo('CLOSE')}
            />
            <ModalConfirm 
                show={!!completedOrderData}
                handleClose={() => handleCloseModalConfirm()}
            />
        </>

    );
}

export default Plan;